import {useLocation} from "react-router-dom"
import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid"

import {StripeDebitCardForm} from "@indebted/stripe"
import {Page} from "@indebted/components/Page"

function DebitCardForm({
	i18n,
	locale,
	onSubmit,
	publishableKey,
	requiresPostcode,
	acceptedCardsList,
	alternativePaymentMethod,
	morePaymentMethodsAvailable,
	walletPay,
	walletPayMethods,
	clientSecret,
	eventPrefix,
	statusURL,
	secureCode,
	requiresEftaDisclosure,
}) {
	const location = useLocation()

	return (
		<Page padded>
			<Grid container direction="column" alignItems="stretch" spacing={5} padding={0} style={{width: "100%"}}>
				<Grid>
					<Typography variant="h6">{i18n.Header}</Typography>
				</Grid>
				<Grid>
					<Typography>{i18n.Title}</Typography>
				</Grid>

				<Grid>
					<StripeDebitCardForm
						i18n={i18n}
						locale={locale}
						onSubmit={onSubmit}
						publishableKey={publishableKey}
						hidePostalCode={!requiresPostcode}
						acceptedCardsList={acceptedCardsList}
						alternativePaymentMethod={alternativePaymentMethod}
						morePaymentMethodsAvailable={morePaymentMethodsAvailable}
						walletPay={walletPay}
						walletPayMethods={walletPayMethods}
						clientSecret={clientSecret}
						paymentMethodSelectionLink={`/${secureCode}/partial-payment/PaymentMethodSelection/${location.search}`}
						eventPrefix={eventPrefix}
						statusURL={statusURL}
						requiresEftaDisclosure={requiresEftaDisclosure}
					/>
				</Grid>
			</Grid>
		</Page>
	)
}

export {DebitCardForm}
